import { FooterData } from "@/shared/types";
import React from "react";
import styles from "./Footer.module.css";

interface FooterProps {
  data: FooterData;
  isCompact?: boolean;
}

const Footer: React.FC<FooterProps> = ({ data, isCompact = true }) => {
  const { socialLinks, sections, copyright, logoUrl } = data;

  return (
    <footer
      className={`${styles.footer} ${
        isCompact ? styles.footerCompact : styles.footerFull
      }`}
    >
      <div className={styles.container}>
        <div
          className={`${styles.content} ${
            isCompact ? styles.contentCompact : styles.contentFull
          }`}
        >
          <div
            className={`${styles.socialSection} ${
              isCompact ? styles.socialSectionCompact : styles.socialSectionFull
            }`}
          >
            <p
              className={`${styles.socialTitle} ${
                isCompact ? styles.socialTitleCompact : styles.socialTitleFull
              }`}
            >
              Подписывайтесь на нас:
            </p>
            <div
              className={`${styles.socialLinks} ${
                isCompact ? styles.socialLinksCompact : styles.socialLinksFull
              }`}
            >
              {socialLinks.map((link) => {
                return (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles.socialLink} ${
                      isCompact
                        ? styles.socialLinkCompact
                        : styles.socialLinkFull
                    }`}
                    aria-label={link.name}
                  >
                    {link.icon}
                  </a>
                );
              })}
            </div>
          </div>

          <div
            className={`${styles.sections} ${
              isCompact ? styles.sectionsCompact : styles.sectionsFull
            }`}
          >
            {sections.map((section, index) => (
              <div key={section.title || index} className={styles.section}>
                {section.title && (
                  <h3
                    className={`${styles.sectionTitle} ${
                      isCompact
                        ? styles.sectionTitleCompact
                        : styles.sectionTitleFull
                    }`}
                  >
                    {section.title}
                  </h3>
                )}
                <div
                  className={`${styles.sectionLinks} ${
                    isCompact
                      ? styles.sectionLinksCompact
                      : styles.sectionLinksFull
                  }`}
                >
                  {section.links.map((link) => (
                    <a
                      key={link.name}
                      href={link.url}
                      className={`${styles.sectionLink} ${
                        isCompact
                          ? styles.sectionLinkCompact
                          : styles.sectionLinkFull
                      }`}
                    >
                      {link.name}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {logoUrl && (
            <div className={styles.logoContainer}>
              <img
                src={logoUrl}
                alt="Destiny Games"
                className={`${styles.logo} ${
                  isCompact ? styles.logoCompact : styles.logoFull
                }`}
              />
            </div>
          )}
        </div>

        <div
          className={`${styles.divider} ${
            isCompact ? styles.dividerCompact : styles.dividerFull
          }`}
        >
          <p className={styles.copyright}>{copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
